export default __webpack_public_path__ + "static/media/img-slide-2.a55afec7.jpeg";